<template>
  <div>
    <section class="columns box">
          <div class="column is-2 left-section">
            <h1 class="is-size-3"><router-link :to="{name: 'lead', params: {leadId: lead.leadId}}">{{lead.name}}</router-link></h1>
            <h2 v-if="isManager">by: {{personName(lead.info)}}</h2>
            <p>added on: {{format_date(lead.addedOn)}}</p>
          </div>
          <div class="column">
            <div class="columns">
              <div class="column">
                <table class="table">
                  <tr v-if="lead.contactName">
                    <th>Contact</th>
                    <td>{{lead.contactName}}</td>
                  </tr>
                  <tr>
                    <th>Address</th>
                    <td>
                      <p>{{`${lead.address || ''} ${lead.address2 ||''}`}}</p>
                      <p>{{`${lead.city || ''}${lead.city ? ',' : ''} ${lead.state || ''} ${lead.zip ||''}`}}</p>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="column" v-if="lead.phone || lead.fax || lead.cell || lead.email">
                <table class="table">
                  <tr v-if="lead.phone">
                    <th>Phone:</th>
                    <td>{{lead.phone}}</td>
                  </tr>
                  <tr v-if="lead.cell">
                   <th>Cell:</th>
                    <td>{{lead.cell}}</td>
                  </tr>
                  <tr v-if="lead.fax">
                    <th>Fax:</th>
                    <td>{{lead.fax}}</td>
                  </tr>
                  <tr v-if="lead.email">
                    <th>Email:</th>
                    <td>{{lead.email}}</td>
                  </tr>
                </table>
              </div>
              <div class="column is-half" v-if="lead.notes">
                <table class="table">
                  <tr>
                    <th>Notes:</th>
                    <td>{{lead.notes}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['lead'],
  methods: {
    format_date(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    personName(info) {
      return info ? info.name : '';
    },
  },
  computed: {
    isManager() {
      return localStorage.getItem('ed-salesRole') === 'manager';
    },
  },
};
</script>

<style scoped>
.table td, .table th  {
  border: none;
}

.box {
  padding: 0;
}

.left-section {
  border-right: 1px solid rgba(10, 10, 10, 0.1);
}
</style>
